import React from "react";
import {UseFormGetValues, UseFormSetValue} from "react-hook-form";
import {useCausaliWF} from "@commons/services/presenze_api/workflow.queries";
import {useValoriPolicies} from "@commons/services/presenze_api/tabelleAzienda.queries";
import {FiltroStati} from "./FiltroStati";
import {FiltroValidita} from "./FiltroValidita";
import Select from "@components/wrapperComponents/Select";
import {FiltroElaborate} from "./FiltroElaborate";
import {UseFormRegister, UseFormResetField} from "react-hook-form/dist/types/form";
import styles from "src/pages/presenze/monitorWF/filtroRichiesteWF.module.css"
import {MonitorWfForm} from "./monitorWF";
import {TabellaWFRecord} from "@commons/mapping/TabellaWFRecord";

interface RichiesteWfFilterProps {
    statiClassName?: string,
    tabellaWF: TabellaWFRecord | undefined,
    setValue: UseFormSetValue<MonitorWfForm>,
    getValues: UseFormGetValues<MonitorWfForm>,
    resetField: UseFormResetField<MonitorWfForm>,
    register: UseFormRegister<MonitorWfForm>,
}

export const RichiesteWfFilter: React.FC<RichiesteWfFilterProps> = ({
                                                                        statiClassName = '',
                                                                        tabellaWF,
                                                                        setValue,
                                                                        getValues,
                                                                        resetField,
                                                                        register,
                                                                    }) => {
    // Carico tabella raggruppamento
    const {elencoValoriTabella} = useValoriPolicies(tabellaWF);

    /* Per caricare i dati della select delle Causali! */
    const {data: causaliWF} = useCausaliWF();

    return (
        <>
            <div className={styles.monitorWfFilterContainer}>
                <div className={styles.filterButtons}>
                    <FiltroStati setValue={setValue} getValues={getValues} statiClassName={statiClassName}/>
                    <FiltroValidita setValue={setValue} getValues={getValues} statiClassName={statiClassName}/>
                    <FiltroElaborate setValue={setValue} getValues={getValues} statiClassName={statiClassName}/>
                </div>

                {/* Combo per selezione causali */}
                <Select label={<div className={styles.selectLabelFilter}><p className="leading-none">Causale</p></div>}
                        id="causale" name="causale" divClass={`${styles.selectDivFilter} sm:px-2`}
                        onClear={() => resetField('causale', {defaultValue: null})}
                        onChange={(e) => {
                            setValue('causale', e.target.value)
                        }}
                        register={register}>
                    <>
                        <option value={""} className={styles.selectOptFilter}>
                            Tutti
                        </option>
                        {causaliWF && causaliWF
                            .map(item => <option key={item.codice} value={item.codice} className={styles.selectOptFilter}>
                                {item.descrizione}
                            </option>)}
                    </>
                </Select>

                {/* Combo per selezione raggruppamento */}
                {tabellaWF && elencoValoriTabella && <Select id="codTabella" name="codTabella"
                                                             label={
                                                                 <div className={styles.selectLabelFilter}>
                                                                     <p className="leading-none text-ellipsis overflow-hidden">{tabellaWF?.descrizioneTipo || "Raggruppamento"}</p>
                                                                 </div>
                                                             }
                                                             divClass={styles.selectDivFilter}
                                                             onClear={() => resetField('codTabella', {defaultValue: null})}
                                                             onChange={(e) => {
                                                                 setValue('codTabella', e.target.value)
                                                             }}
                                                             register={register}>
                    <>
                        <option value={""} className={styles.selectOptFilter}>
                            Tutti
                        </option>
                        {elencoValoriTabella.map(item => (
                            <option key={item.id} value={item.id!} className={styles.selectOptFilter}>
                                {item.descrizione}
                            </option>))}
                    </>
                </Select>}

            </div>
        </>
    )
};
